import React from 'react';
import PropTypes from 'prop-types';
import AdminPagination from '../../Pagination';

const CollectedDetailsFooter = ({
  total,
  page,
  perPage,
  handleChangePage,
}) => (
  <div className="table-footer">
    <AdminPagination
      total={total}
      page={page}
      perPage={perPage}
      handleChangePage={handleChangePage}
    />
  </div>
);

CollectedDetailsFooter.propTypes = {
  total: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
};

export default CollectedDetailsFooter;
